









import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Menu2'
})
export default class extends Vue {}
